export default {
  left: {
    opacity: [1, 0],
    translateX: [0, -30],
  },
  top: {
    opacity: [1, 0],
    translateY: [0, -30],
  },
  right: {
    opacity: [1, 0],
    translateX: [0, 30],
  },
  bottom: {
    opacity: [1, 0],
    translateY: [0, 30],
  },
  alpha: {
    opacity: [1, 0],
  },
  scale: {
    opacity: [1, 0],
    scale: [1, 0],
  },
  scaleBig: {
    opacity: [1, 0],
    scale: [1, 2],
  },
  scaleX: {
    opacity: [1, 0],
    scaleX: [1, 0],
  },
  scaleY: {
    opacity: [1, 0],
    scaleY: [1, 0],
  },
};



// WEBPACK FOOTER //
// ./src/animTypes.js